export default __webpack_public_path__ + "static/media/icon1.10546a27.svg";